import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import ContactListView from './View'
import './styles.css'

class ContactsTab extends Component {

  constructor(props) {
    super(props)

    this.state = {
      filterValue: 'all',
    }
  }

  componentDidMount() {
    this.props.getContacts()
  }

  onFilterChange = (e) => {
    e.stopPropagation()
    this.setState({ filterValue: e.target.value })
  }

  filterContacts = (contacts) => {
    switch (this.state.filterValue) {
      case 'leads': {
        return this.allLeads(contacts)
      }
      case 'conversions': {
        return this.allConversions(contacts)
      }
      default: {
        return contacts
      }
    }
  }

  allLeads = contacts => (
    contacts.filter(
      contact => contact.conversion_time === null &&
        contact.contactable_id == null,
    )
  )

  allConversions = contacts => (
    contacts.filter(
      contact => !!contact.conversion_time || contact.conversion_time === 0,
    )
  )

  render() {
    const { contacts, contactsFetched, conversionStats, handleContactEdit } = this.props
    const { filterValue } = this.state
    const filteredContacts = this.filterContacts(contacts)

    return (
      contactsFetched ? (
        <ContactListView
          contacts={filteredContacts}
          conversionStats={conversionStats}
          onFilterChange={this.onFilterChange}
          filterValue={filterValue}
          handleContactEdit={handleContactEdit}
        />
      ) : (
        <div className="loader">
          <RefreshIndicator
            size={50}
            top={100}
            left={0}
            status={'loading'}
            color="#1B78B3"
          />
        </div>
      )
    )
  }
}

ContactsTab.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object).isRequired,
  contactsFetched: PropTypes.bool.isRequired,
  conversionStats: PropTypes.object.isRequired,
  getContacts: PropTypes.func.isRequired,
  handleContactEdit: PropTypes.func.isRequired,
}

export default ContactsTab



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/index.js